import { Head, router } from '@inertiajs/react'
import { format } from 'date-fns'
import ContributionCalendar from '../components/Dashboard/ContributionCalendar'
import StatsCard from '../components/Dashboard/StatsCard'

type DailyCount = { date: string; count: number }

interface Stats {
  today_count: number
  weekly_count: number
  last_week_count: number
  total_count: number
  total_focus_time: number
  month_count: number
  focus_time_in_month: number
  yesterday_count: number
  yesterday_focus_time: number
}

interface DashboardProps {
  year: number
  month: number
  daily_counts: DailyCount[]
  stats: Stats
}

const clockIcon = (color: string) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`w-6 h-6 ${color}`}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
)

export default function Dashboard({ year, month, daily_counts, stats }: DashboardProps) {
  // JS Date months are 0-based; server month is 1-based.
  const currentMonth = new Date(year, month - 1, 1)

  const handleMonthChange = (newDate: Date) => {
    router.get(
      '/dashboard',
      { year: newDate.getFullYear(), month: newDate.getMonth() + 1 },
      { preserveState: true, preserveScroll: true, only: ['year', 'month', 'daily_counts', 'stats'] },
    )
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Head title="数据面板" />
      <h1 className="text-2xl font-bold mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatsCard title="今日番茄钟" value={stats.today_count} icon={clockIcon('text-amber-500')} />
        <StatsCard title="今日专注时间" value={`${((stats.today_count * 25) / 60).toFixed(1)} 小时`} icon={clockIcon('text-amber-500')} />
        <StatsCard title="昨日番茄钟" value={stats.yesterday_count} icon={clockIcon('text-purple-500')} />
        <StatsCard title="昨日专注时间" value={`${stats.yesterday_focus_time} 小时`} icon={clockIcon('text-purple-500')} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatsCard title="本月番茄钟" value={stats.month_count} icon={clockIcon('text-amber-500')} />
        <StatsCard title="本月专注时间" value={`${stats.focus_time_in_month} 小时`} icon={clockIcon('text-amber-500')} />
        <StatsCard title="总番茄钟" value={stats.total_count} icon={clockIcon('text-green-500')} />
        <StatsCard title="总专注时间" value={`${stats.total_focus_time} 小时`} icon={clockIcon('text-purple-500')} />
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-semibold mb-2">{format(currentMonth, 'yyyy年 M月')} 番茄钟日历</h2>
        <ContributionCalendar data={daily_counts} currentMonth={currentMonth} onMonthChange={handleMonthChange} />
      </div>
    </div>
  )
}
